import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PDFExport } from "@progress/kendo-react-pdf";
import PageTemplate from './PageTemplate';
import AssessmentScore from './Components/AssessmentScore';
import AssessmentDetails from './Components/AssessmentDetails';
import AssessmentTop5 from './Components/AssessmentTop5';
import AssessmentAllInOne from './Components/AssessmentAllInOne';
import AssessmentCategories from './Components/AssessmentCategories';
import { MdArrowBack } from "react-icons/md";

class AssessmentReport extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.hindiPDFstatic = [...Array(700).keys()].map((index) => (React.createRef()))
    this.state = {
      crrSelectedEmp: "",
      languageName: 'English',
      languageShortName: 'en'
    }
  }

  componentDidMount() {

  }

  exportPDFWithComponent = async () => {

    if (this.state.languageShortName === 'hi') {

    } else {
      if (this.pdfExportComponent.current) {
        this.pdfExportComponent.current.save();
      }
    }
  };

  handleSelectEmployee = (value) => {
    this.setState({ crrSelectedEmp: value }, () => {
      let { onAssessmentByEmpID } = this.props;
      let emp_id = "";
      if (value && value.emp_id) {
        emp_id = value.emp_id;
      } else {
        emp_id = value.emp_id;
      }
      onAssessmentByEmpID(emp_id)

    })
  }

  handleLanguageLabel = (data) => {
    this.setState({
      languageName: data.name,
      languageShortName: data.shortName
    })
  }

  handleBack = () => {
    window.history.back();
  };

  render() {

    let { showPageType, surveyLanguageCode, sendPDFMail, onDownloadAssessmentType2ByEmpID, getAssessmenrEmployeeDetailsData, closeReportModal, getTranslateElementAllData, getAssessmentReportByEmpIDData, createdAt } = this.props;
    let { languageName } = this.state;
    let languageShortName = surveyLanguageCode;

    const GetTextByLanguage = (name, text) => {
      if (languageShortName && languageShortName !== "en") {
        let sentence = "";
        if (getTranslateElementAllData && getTranslateElementAllData.length > 0) {
          let getIndex = getTranslateElementAllData.findIndex(prev => prev.name === name);
          if (getIndex !== -1) {
            sentence = getTranslateElementAllData && getTranslateElementAllData[getIndex] && getTranslateElementAllData[getIndex]["transl"] && getTranslateElementAllData[getIndex]["transl"][languageShortName] ? getTranslateElementAllData[getIndex]["transl"][languageShortName] : ""
          }
        }
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    const GetDetailsByLanguage = (element, name, text) => {
      if (languageShortName && languageShortName !== "en") {
        let sentence = element && element["details"] && element["details"]["transl"] && element["details"]["transl"][languageShortName] && element["details"]["transl"][languageShortName][name] ?
          element["details"]["transl"][languageShortName][name] : ""
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    function EditButtonFn(name, text) {
      return (
        <>
          {GetTextByLanguage(name, text)}
        </>
      )
    }
    function EditDetailsFn(element, name, text) {
      return (
        <>
          {GetDetailsByLanguage(element, name, text)}
        </>
      )
    }

    const isMobile = window.innerWidth <= 700;

    return (

      <>
        {/* Mobile report design  */}
        {isMobile ?
          <div className="min-h-screen mx-auto w-full overflow-hidden">
            <div className="lg:w-[580px] lg:h-[720px] w-full h-full rounded-xl bg-gradient-to-br from-pink-100 via-blue-100 to-purple-200 flex flex-col items-center text-center px-8 py-10 overflow-hidden">
              <div className="flex items-center gap-2 mb-6">
                <img src="/img/assessment/TalentPlusStrengths_logo.svg" className="w-44" />
              </div>
              <h1 className="lg:text-4xl text-3xl font-bold text-gray-900 leading-tight">TALENTPLUSSTRENGTHS</h1>
              <h1 className="lg:text-4xl text-3xl font-bold text-gray-900 leading-tight">ASSESSMENT</h1>
              <h1 className="lg:text-4xl text-3xl font-bold text-gray-900 leading-tight mb-8">REPORT</h1>
              <div className="relative w-80 h-96">
                <div className="absolute inset-0 bg-white rounded-[40px] shadow-lg"></div>
                <img src="/img/assessment/talentplus_assessment_report_v2.webp" alt="report" className="relative w-full h-full object-cover rounded-[40px] border-8 border-white" />
              </div>
              {/* <div className="text-center max-w-sm my-8 space-y-1">
              <p className="text-base text-[#212121] font-medium">{EditButtonFn("page_1_footer_text_1", `HappyPlus Online Assessments Copyright 2025`)}</p>
              <p className="text-sm font-normal text-[#212121]/70 italic">{EditButtonFn("page_1_confidential_text_1", "This report is confidential and should not be distributed without permission")}</p>
            </div> */}
              <button
                onClick={() => {
                  languageShortName !== "en"
                    ? onDownloadAssessmentType2ByEmpID(
                      this.state.crrSelectedEmp?.emp_id || "",
                      languageShortName
                    )
                    : this.exportPDFWithComponent();
                }}
                className="flex items-center mt-8 px-8 py-3.5 bg-gray-800 text-white rounded-full text-sm font-medium shadow-md hover:scale-105 transition">
                <span className="material-symbols-outlined mr-2">
                  file_download
                </span>
                Download Report PDF </button>
            </div>
          </div>
          :
          <div className='mx-auto lg:w-5/6 w-full border'>
            <div className="sticky -top-9 z-40 border-b overflow-hidden overflow-y-auto bg-white ">
              <div className="flex flex-col lg:flex-row items-center justify-between p-4 px-6 gap-4">
                <div className="flex md:flex-row flex-col items-center gap-2 w-full md:w-auto">
                  <button onClick={this.handleBack} className="inline-flex items-center justify-center w-10 h-10 text-gray-500 bg-gray-100 rounded-full hover:text-gray-800">
                    <MdArrowBack size={24} />
                  </button>
                  <h1 className="text-base font-semibold text-[#212121] md:text-lg">
                    {EditButtonFn(
                      "TalentAssessmentReport",
                      "TalentPlusStrengths Assessment Report"
                    )}
                  </h1>

                </div>
                {getAssessmentReportByEmpIDData?.length > 0 && (
                  <button
                    onClick={() => {
                      languageShortName !== "en"
                        ? onDownloadAssessmentType2ByEmpID(
                          this.state.crrSelectedEmp?.emp_id || "",
                          languageShortName
                        )
                        : this.exportPDFWithComponent();
                    }}
                    // onClick={() => sendPDFMail(languageShortName)}
                    className="flex items-center py-3.5 px-4 text-sm border rounded-md font-medium text-[#212121] w-full md:w-auto"
                  >
                    <span className="material-symbols-outlined mr-2">
                      file_download
                    </span>
                    Download PDF
                  </button>
                )}

              </div>
            </div>


            {getAssessmentReportByEmpIDData && getAssessmentReportByEmpIDData.length > 0 ?
              <div >
                <PDFExport ref={this.pdfExportComponent}
                  pageTemplate={(pageObj) => <PageTemplate pageNum={pageObj.pageNum} />}
                  scale={0.6}
                  forcePageBreak=".page-break"
                  paperSize="A4"
                  margin={0}
                  fileName={'Assessment Report' + (this.state.crrSelectedEmp && this.state.crrSelectedEmp.name ?
                    ' - ' + this.state.crrSelectedEmp.name : "")}
                  author="Happyplus Team"
                  landscape={false}
                >

                  <AssessmentScore
                    crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                    createdAt={createdAt}
                    hindiPDFstatic={this.hindiPDFstatic}
                    reportCount={"28"}
                  />

                  <AssessmentTop5
                    crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                    createdAt={createdAt}
                    hindiPDFstatic={this.hindiPDFstatic}
                  />

                  <AssessmentCategories
                    crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    getAssessmenrEmployeeDetailsData={getAssessmentReportByEmpIDData}
                    EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                    createdAt={createdAt}
                    hindiPDFstatic={this.hindiPDFstatic}
                  />

                  <AssessmentAllInOne
                    crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    getAssessmenrEmployeeDetailsData={getAssessmentReportByEmpIDData}
                    EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                    createdAt={createdAt}
                    hindiPDFstatic={this.hindiPDFstatic}
                  />

                  <AssessmentDetails
                    crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                    createdAt={createdAt}
                    hindiPDFstatic={this.hindiPDFstatic}
                  />
                </PDFExport>
              </div>
              : <div className='py-24 text-2xl font-bold text-center text-gray-500'>{"Loading..."}</div>}
          </div>}
      </>
    );
  }
}
function mapStateToProps(state) {
  // //////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(AssessmentReport);
